import { DashboardStyled } from './dashboard.styled';
import Header from './components/header/header';
import Sidebar from './components/sidebar/sidebar';
import PageContainer from './components/page-container/page-container';
import { useNavigate } from 'react-router-dom';
import { useCallback, useMemo, useState } from 'react';
import i18n from '../../../translations/strings';
import { useSelector } from 'react-redux';
import { UserTypeVariant } from '../../../store/user.store';

export interface DashboardProps {
  callingPage: 'BookingPage' | 'ReservationListPage' | 'RoomsListPage' | 'AllEventsPage' | 'ReservationListAdminPage' | 'HandleReservationAdminPage' | 'AdminNewReservationPage' | 'EventsListAdminPage'
  children: any;
}

const Dashboard = (props: DashboardProps) => {
  const { userType } = useSelector((state: any) => {
    return state.user;
  });

  const navigate = useNavigate();
  const [pageSelected, setPageSelected] = useState(props.callingPage);
  const [isHamburgerClicked, setIsHamburgerClicked] = useState(false);
  const onHamburgerClick = useCallback(() => {
    setIsHamburgerClicked(currentState => !currentState);
  }, []);

  const buttonsCustomer = useMemo(() => {
    return [
      {
        id: 'RoomsListPage',
        text: i18n.t('dashboard.ourRoomsButtonName'),
        onClick: () => {
          setPageSelected('RoomsListPage');
          navigate('/customer/rooms');
        },
      },
      {
        id: 'BookingPage',
        text: i18n.t('dashboard.bookingPageButtonName'),
        onClick: () => {
          setPageSelected('BookingPage');
          navigate('/customer/booking');
        },
      },
      {
        id: 'ReservationListPage',
        text: i18n.t('dashboard.reservationListPagePageButtonName'),
        onClick: () => {
          setPageSelected('ReservationListPage');
          navigate('/customer/reservation-list');
        },
      },
    ];
  }, [navigate]);

  const buttonsAdmin = useMemo(() => {
    return [
      {
        id: 'AllEventsPage',
        text: i18n.t('dashboard.allEventsAdmin'),
        onClick: () => {
          setPageSelected('AllEventsPage');
          navigate('/admin/all-events');
        },
      },
      {
        id: 'ReservationListAdminPage',
        text: i18n.t('dashboard.reservationsListAdmin'),
        onClick: () => {
          setPageSelected('ReservationListAdminPage');
          navigate('/admin/reservation-list-admin');
        },
      },
      {
        id: 'EventsListAdminPage',
        text: i18n.t('dashboard.eventsList'),
        onClick: () => {
          setPageSelected('EventsListAdminPage');
          navigate('/admin/events-list/');
        },
      },
      {
        id: 'HandleReservationAdminPage',
        text: 'Gestisci prenotazione',
        onClick: () => {
          setPageSelected('HandleReservationAdminPage');
          navigate('/admin/handle-reservation-admin');
        },
      },
      {
        id: 'AdminNewReservationPage',
        text: 'Nuova prenotazione',
        onClick: () => {
          setPageSelected('AdminNewReservationPage');
          navigate('/admin/admin-new-reservation');
        },
      },
    ];
  }, [navigate]);

  const ButtonsSidebarDashboard: any = {
    [UserTypeVariant.Customer]: buttonsCustomer,
    [UserTypeVariant.Admin]: buttonsAdmin,
  };

  return (
    <DashboardStyled.MainContainer>
      <Header onHamburgerClick={onHamburgerClick} />
      <DashboardStyled.SidebarAndContentContainer container>
        <Sidebar
          buttons={ButtonsSidebarDashboard[userType]}
          pageSelected={pageSelected}
          isHamburgerClicked={isHamburgerClicked}
        />
        <PageContainer isHamburgerClicked={isHamburgerClicked}>
          {props.children}
        </PageContainer>
      </DashboardStyled.SidebarAndContentContainer>
    </DashboardStyled.MainContainer>
  );
};

export default Dashboard;
